<template>
  <div class="modal-mask" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <b-tabs content-class="mt-3" fill>
          <b-tab title="Класс" active>
            <div class="form-group">
              <div class="d-flex justify-content-between" v-if="productEdit.category">
                <div>Категория</div>
                <div>{{ productEdit.category.code }} {{ productEdit.category.title }}</div>
              </div>
              <div class="d-flex justify-content-between">
                <label>Наименование [RU]</label>
                <span>ID: {{ productEdit.id }}</span>
              </div>
              <input type="text" class="form-control" v-model="productEdit.title" disabled/>
            </div>
            <div class="form-group">
              <label>Код</label>
              <input type="text" class="form-control" v-model="productEdit.code" disabled/>
            </div>
            <div class="form-group">
              <label>Единица измерения</label>
              <select class="form-control" v-model="productEdit.unit_id" disabled="">
                <option v-for="(unit, index) in units" :key="index"
                        :value="unit.id"
                        :selected="unit.id === productEdit.unit_id"
                        disabled
                >{{ unit.title }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Тип</label>
              <select class="form-control" v-model="productEdit.type">
                <option value="0">Не определен</option>
                <option value="1">Товар</option>
                <option value="2">Работа</option>
                <option value="3">Услуга</option>
              </select>
            </div>
            <div class="form-group">
              <label>Дата удаления (Не обязательно)</label>
              <date-picker class="w-100" v-model="productEdit.delete_at" valueType="format"></date-picker>
            </div>
          </b-tab>
          <b-tab title="Добавить перевод">
            <div class="form-group">
              <label>Язык</label>
              <select class="form-control" @change="onSelectProductLang()" v-model="productEdit.language">
                <option disabled>Выберите тип</option>
                <option
                    v-if="!inArray(language.lang ,productEdit.translations,2)"
                    v-for="language in languages"
                    :value="language.lang"
                    :key="language.id"
                >{{ language.lang }}
                </option>
              </select>
            </div>
            <div class="form-group" v-if="productEdit.language != null">
              <div class="form-group">
                <label>Наименование [{{ productEdit.language }}]</label>
                <input type="text" class="form-control" v-model="productEdit[productEdit.language + '_title']"/>
              </div>
              <div class="form-group">
                <label>Описание [{{ productEdit.language }}]</label>
                <input type="text" class="form-control" v-model="productEdit[productEdit.language + '_comment']"/>
              </div>
            </div>
          </b-tab>
          <b-tab title="Существует">
            <div v-for="translation in productEdit.translations" :key="translation.id">
              <p>[{{ translation.locale }}] - {{ translation.title }}</p>
            </div>
          </b-tab>
        </b-tabs>

        <div class="modal-footer">
          <slot name="footer">
            <button class="modal-button btn btn-danger" @click="updateTab()">Закрыть</button>
            <button class="modal-button btn btn-success" @click="productUpdate()">Изменить</button>
          </slot>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {POST} from "@/shared/api";
import {funcs} from "@/_helpers/_sumple_funcs";

export default {
  name: "productEdit",
  props: {
    showProductModal: false,
    productEdit: {},
    units: null,
    languages: []
  },
  methods: {
    updateTab(event = 'update', spec = false) {
      this.$emit(event, spec);
      // console.log(this.specification.fields);

    },
    onSelectProductLang() {
      for (let index = 0; index < this.productEdit.translations.length; index++) {
        if (this.productEdit.translations[index].locale === this.productEdit.language) {
          this.productEdit[this.productEdit.language + '_title'] = this.productEdit.translations[index].title
        }
      }
    },
    productUpdate() {
      POST(this.productEdit, "/productUpdate", this).then(response => {
        this.updateTab('update', {state: "success", response: response});

      });
    },
    inArray(lang ,translations,mode){
      if (!Array.isArray(translations)){
        return false;
      }
      let res = [];
      let locales = [];
      if (mode === 2){
        translations.forEach((el) => {
          locales.push(el.locale);
        });
        res = locales
      }else {
        res = translations;
      }
      return funcs.inArray(lang ,res)
    }
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
